import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/toaster";
import Home from "@/pages/Home";
import Inscripcion from "@/pages/Inscripcion";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/inscripcion" element={<Inscripcion />} />
      </Routes>
      <Toaster />
    </BrowserRouter>
  );
}
